module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "simple-tooltip-wrapper",
    on: {
      "mouseenter": _vm.showTooltip,
      "mouseleave": _vm.hideTooltip
    }
  }, [_vm._t("default"), _vm._v(" "), (_vm.visible) ? _c('div', {
    staticClass: "simple-tooltip",
    class: [("tooltip-" + _vm.placement)]
  }, [_vm._v("\n    " + _vm._s(_vm.content) + "\n    "), _c('div', {
    staticClass: "tooltip-arrow",
    class: [("arrow-" + _vm.placement)]
  })]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3635d9d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SimpleTooltip.vue
// module id = 1659
// module chunks = 1